import { api } from '@src/lib/api-client';
import { AxiosResponse } from 'axios';

type PostBalanceFetchesResponse = {
  jobId: string;
  status: string;
};

export async function postBalanceFetches(
  accountId: string,
): Promise<PostBalanceFetchesResponse> {
  return await api
    .post(`/api/v3/user/accounts/${accountId}/balance-fetches`, {
      account_id: accountId,
    })
    .then((res: AxiosResponse<PostBalanceFetchesResponse>) => {
      if (res.data.status === 'not_found') {
        throw new Error(res.data.status);
      }
      return res.data;
    });
}
